import { Navigate, useParams } from "react-router"
import { useAppState } from "../overmind"
import Loading from "./Loading"


export const CourseCodeRedirect = () => {
    const { code = "" } = useParams()
    const state = useAppState()

    // The route tree mounts as soon as the user is known, before the course list has
    // loaded. Redirecting on an empty list would discard the course code, so wait.
    if (state.isLoading) {
        return <Loading />
    }

    // find course with the given code
    // multiple courses can have the same code, so we take the one with the highest year
    const courses = state.courses.filter(course => course.code.toLowerCase() === code.toLowerCase())
    if (courses.length === 0) {
        // no course found with the given code
        return <Navigate to="/" replace />
    }

    // find the course with the highest year
    const course = courses.reduce((prev, current) => {
        return (prev.year > current.year) ? prev : current
    })

    return <Navigate to={`/course/${course.ID}`} replace />
}

export default CourseCodeRedirect
